export class Role
{
  id: string;
  name: string;
  disabled: boolean;
}



// WEBPACK FOOTER //
// ./src/app/users/models/role.ts